"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const IconImage_1 = __importDefault(require("../../../assets/icons/IconImage"));
// import ImagePicker from 'react-native-image-picker';
const ImagePickers = (props) => {
    const onClick = () => {
        const inputElement = document.getElementById('file-upload');
        if (inputElement) {
            inputElement.click();
        }
    };
    const handleImageUploadWeb = (event) => {
        const files = event.target.files;
        const dataImage = [];
        if (!files || files.length === 0)
            return;
        if (files.length > 30) {
            return false;
        }
        const reader = new FileReader();
        const images = [];
        const readFile = (index) => {
            if (index >= files.length) {
                if (props.formDataImage) {
                    props.formDataImage(dataImage);
                }
                props.onSelect(images);
                // Reset input[type="file"] để cho phép chọn lại cùng một tệp
                event.target.value = '';
                return;
            }
            const file = files[index];
            const fileSizeInMB = file.size / (1024 * 1024);
            if (fileSizeInMB > 10) {
                readFile(index + 1);
                return;
            }
            dataImage.push(file);
            reader.onload = () => {
                const imgDataUrl = reader.result;
                images.push(imgDataUrl);
                readFile(index + 1);
            };
            reader.readAsDataURL(file);
        };
        readFile(0);
    };
    if (react_native_1.Platform.OS === 'web') {
        return (react_1.default.createElement(react_native_1.View, { style: styles.container },
            react_1.default.createElement("input", { type: "file", accept: "image/png, image/jpeg, image/jpg, image/webp", onChange: handleImageUploadWeb, style: { display: "none" }, id: "file-upload", multiple: true }),
            react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => {
                    onClick();
                } },
                react_1.default.createElement(IconImage_1.default, null))));
    }
};
const styles = react_native_1.StyleSheet.create({
    container: {},
});
exports.default = ImagePickers;
